import React from "react";
import "./air.css";

const Question = ({ question, onChange, selectedAnswers, showAnswers }) => {
  const { id, title, imgURL, answers } = question;
  const options = ["red", "orange", "yellow", "green"];

  return (
    <>
      <div className="air question-title">{title}</div>
      {/* </div> */}
      <div className="question-img-container">
        {imgURL && (
          <img
            src={imgURL}
            alt="Question illustration"
            className="question-image"
          />
        )}
        {imgURL && (
          <img
            src={"/images/air/07_quiz/page7_quizall_pyramide.svg"}
            alt="Riskiko Grupp illustration"
            className="question-image"
          />
        )}
      </div>
      <div className="answer-choices">
        {answers &&
          answers.map((answer, index) => (
            <div
              key={index}
              className={`inside-answers ${
                answer.checked && !showAnswers ? "active" : ""
              } 
                            ${showAnswers ? "disabled" : ""} 
                            ${
                              showAnswers &&
                              selectedAnswers &&
                              selectedAnswers.find(
                                (p) => p.id === index + 1 && p.checked
                              )
                                ? "active"
                                : ""
                            }
                            ${
                              showAnswers &&
                              selectedAnswers &&
                              selectedAnswers.find(
                                (p) => p.id === index + 1 && p.correct
                              )
                                ? `correct-answer ${options[index]}`
                                : ""
                            }
                                `}
            >
              <input
                value={showAnswers ? false : answer.checked}
                type="checkbox"
              />
              <div
                className="answer-content"
                onClick={onChange.bind(this, id, index)}
                data-question-id={id}
                id={answer.id}
              >
                <span className="answer-text">{answer.title}</span>
              </div>
            </div>
          ))}
      </div>
    </>
  );
};

export default Question;
